import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

/**
 * Initialize testimonials carousels with scoped navigation
 * Supports multiple instances per page
 */
const initTestimonialsCarousels = () => {
  const testimonialsCarousels = document.querySelectorAll(
    '.testimonials-carousel__swiper'
  );

  if (testimonialsCarousels.length === 0) {
    return;
  }

  testimonialsCarousels.forEach((container, index) => {
    const parentBlock = container.closest('.testimonials-carousel');

    if (!parentBlock) {
      console.warn(
        `Testimonials carousel ${index + 1}: Parent block not found`
      );
      return;
    }

    const nextButton = parentBlock.querySelector('.swiper-button-next');
    const prevButton = parentBlock.querySelector('.swiper-button-prev');

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 24,
      breakpoints: {
        580: {
          slidesPerView: 1.5,
        },
        765: {
          slidesPerView: 2,
        },
      },
    };

    if (nextButton && prevButton) {
      swiperConfig.navigation = {
        nextEl: nextButton,
        prevEl: prevButton,
      };
    } else {
      console.warn(
        `Testimonials carousel ${index + 1}: Navigation buttons not found`
      );
    }

    try {
      new Swiper(container, swiperConfig);
    } catch (error) {
      console.error(
        `Failed to initialize testimonials carousel ${index + 1}:`,
        error
      );
    }
  });
};

domReady(initTestimonialsCarousels);
